import { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { api, apiErr } from "@/lib/api";
import { AuthShell } from "@/pages/Login";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Loader2 } from "lucide-react";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (err) {
      toast.error(apiErr(err));
    } finally {
      setLoading(false);
    }
  };

  if (sent) return (
    <AuthShell title="Check your email" subtitle={`If an account exists for ${email}, a reset link is on its way.`}>
      <p className="text-sm text-muted-foreground mb-4">The link works once, for 30 minutes. Nothing there? Check spam, or ask again in a few minutes.</p>
      <Link to="/login" className="text-foreground underline text-sm">Back to sign in</Link>
    </AuthShell>
  );

  return (
    <AuthShell title="Forgot your password?" subtitle="We'll email you a link to choose a new one.">
      <form onSubmit={submit} className="space-y-4">
        <div className="space-y-1.5">
          <Label htmlFor="forgot-email">Email</Label>
          <Input id="forgot-email" type="email" autoComplete="username" value={email} required
            onChange={(e) => setEmail(e.target.value)} placeholder="you@company.dev" data-testid="forgot-email" />
        </div>
        <Button type="submit" className="w-full" disabled={loading || !email} data-testid="forgot-submit">
          {loading && <Loader2 className="w-4 h-4 animate-spin" />} Email me a reset link
        </Button>
        <Link to="/login" className="block text-center text-sm text-muted-foreground hover:text-foreground">Back to sign in</Link>
      </form>
    </AuthShell>
  );
}
